'use strict';

const TEMPLATES = {
  main: require('../main.html.mustache'),
};
class CrossSellBait {
  constructor({ $offers }) {
    this.scrollHandler = this.scrollHandler.bind(this);
    this.click = this.click.bind(this);
    this.mouseEnter = this.mouseEnter.bind(this);
    this.mouseLeave = this.mouseLeave.bind(this);
    this.$offers = $offers;

    if ($('#multiple-offers').length > 0) {
      return;
    }

    const data = {
      placeName: $('.mpp-container').data('place-name'),
    };

    data.t = data.translate = () => str => I18n.t(str);

    this.$el = $(TEMPLATES.main.render(data));
    this.$overlay = this.$el.find('.cross-sell-bait-hover');
    this.$arrowCircle = this.$overlay.find('.arrow-circle');
    this.$arrowWrapper = this.$overlay.find('.arrow-wrapper');
    this.$el.click(this.click);
    this.$el.hover(this.mouseEnter, this.mouseLeave);
    $('body').append(this.$el);
    this.animate();
    this.debounceScroll = null;
    $(window).on('scroll', this.scrollHandler);
  }

  scrollHandler() {
    if (this.debounceScroll != null) {
      clearTimeout(this.debounceScroll);
    }

    this.debounceScroll = setTimeout(() => {
      if (
        $(window).scrollTop() >
        $('.mpp-container .merchant-information-row').offset().top
      ) {
        return this.$el.slideUp('fast');
      } else {
        return this.$el.slideDown('slow');
      }
    }, 100);
    return this.debounceScroll;
  }

  click() {
    this.$overlay.hide();
    const duration = 500;
    return $('html, body').animate(
      {
        scrollTop: this.$offers.offset().top - 10,
      },
      duration,
      () => {
        return this.$el.slideUp('fast');
      }
    );
  }

  mouseEnter() {
    this.$overlay.show();
    this.slideUp(this.$arrowCircle);
    return this.slideUp(this.$arrowWrapper, 50);
  }

  mouseLeave() {
    this.$overlay.hide();
    this.$arrowCircle.addClass('hidden').removeClass('animate-slide-up');
    return this.$arrowWrapper
      .addClass('hidden')
      .removeClass('animate-slide-down');
  }

  animate() {
    this.$el.slideDown('fast', () => {});
    this.slideDown(this.$el.find('.mpp-icon-map-pin-empty'));
    this.slideDown(this.$el.find('.mpp-icon-map-pin-star'), 100);
    this.slideDown(this.$el.find('.cross-sell-title'), 300);
    this.slideDown(this.$el.find('.cross-sell-place-name'), 300);
    const $icons = this.$el.find('.cross-sell-bait-icons span');
    let timeout = 500;
    return (() => {
      const result = [];

      for (const icon of $icons) {
        this.slideDown($(icon), timeout);
        result.push((timeout += 100));
      }

      return result;
    })();
  }

  slideUp(element, timeout = 0) {
    return setTimeout(() => {
      return $(element)
        .addClass('animate-slide-up')
        .removeClass('hidden');
    }, timeout);
  }

  slideDown(element, timeout = 0) {
    return setTimeout(() => {
      return $(element)
        .addClass('animate-slide-down')
        .removeClass('hidden');
    }, timeout);
  }
}

module.exports = CrossSellBait;
